import type { FC } from 'react';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { Provider } from '@vgtv/api-client';

import { Overlay } from '../../Overlay/Overlay';
import type { Section } from '../../../services/sps/salesposter';
import type { ProviderSubscriptionMap } from '../../../services/tracking/pulseEvents';

import { VGPaywallPopup } from './VGPaywallPopup';

import * as styles from './PaywallPopup.module.scss';

interface Props {
  asset?: SvpAssetAdditional;
  entityId?: string;
  isOpen: boolean;
  onCloseButtonClick: () => void;
  access: ProviderSubscriptionMap[Provider.VGTV];
  section: Section;
  onLoadFailure: (thrownValue: unknown) => void;
}

export const PaywallPopup: FC<Props> = ({
  asset,
  entityId,
  isOpen,
  onCloseButtonClick,
  access,
  section,
  onLoadFailure,
}) => {
  return (
    <Overlay
      type="overlay/popup"
      forceRender
      isOpen={isOpen}
      onCloseButtonClick={onCloseButtonClick}
      className={styles.popup}
      contentClassName={styles.popupContent}
    >
      <VGPaywallPopup
        entityId={String(entityId || asset?.id || '')}
        access={access}
        section={section}
        onLoadFailure={onLoadFailure}
        isOpen={isOpen}
      />
    </Overlay>
  );
};
